<template>
  <div class="text-center">
    <v-pagination
      v-if="paginacionActual.cantidadPaginas > 1"
      v-model="paginacionActual.pagina"
      @input="setPagina"
      :length="paginacionActual.cantidadPaginas"
      :total-visible="5"
    ></v-pagination>
    <v-row
      no-gutters
      align="center"
      justify="center"
      v-if="paginacionActual.cantidadRegistros"
    >
      <span
        :class="
          `${
            $vuetify.breakpoint.smAndDown ? 'body-1' : ''
          } background fonts--text text--secondary mt-5 py-2`
        "
        style="font-weight: black; width: 500px;"
      >
        Resultados encontrados {{ paginacionActual.cantidadRegistros }}
      </span>
    </v-row>
  </div>
</template>

<script>
import axios from '@/config/axios';
import { mapGetters } from 'vuex';
export default {
  data: () => ({}),
  computed: {
    ...mapGetters('process', [
      'getPaginacionProcesos',
      'getPaginacionSujetos',
      'getPaginacionActuaciones',
      'getStatus',
      'getTab',
    ]),

    paginacionActual() {
      if (this.getTab === 1) {
        return this.getPaginacionSujetos;
      } else if (this.getTab === 3) {
        return this.getPaginacionActuaciones;
      } else {
        return this.getPaginacionProcesos;
      }
    },
  },
  methods: {
    async setPagina(pagina) {
      if (this.getTab === 1) {
        this.$store.dispatch('process/setPaginaSujetos', pagina);
      } else if (this.getTab === 2) {
        // this.$store.dispatch('process/setPaginaSujetos', pagina)
      } else if (this.getTab === 3) {
        this.$store.dispatch('process/setPaginaActuaciones', pagina);
      } else {
        
        this.$store.dispatch('process/setPaginaProcesos', pagina);
      }
    },
  },
};
</script>
